import React from 'react';
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const LiveChatButton = ({ isFinanceSection }) => {
  const DELAY = 20;
  const [status, setStatus] = useState('loading');
  const [timeExpired, setTimeExpired] = useState(false);
  const liveChatRef = useRef(null);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setStatus('loaded');
    });

    const livePersonTimer = setTimeout(() => {
      observer.disconnect();
      setTimeExpired(true);
    }, DELAY * 1000);

    observer.observe(liveChatRef.current, { subtree: true, childList: true });
    return () => {
      clearTimeout(livePersonTimer);
    };
  }, []);

  useEffect(() => {
    if (timeExpired && status === 'loading') {
      setStatus('failed');
    }
  }, [timeExpired]);

  return (
    <>
      {status === 'failed' ? (
        <button
          className="ch-btn productheader__contact ch-fs--2 ch-width--12"
          disabled
          type="button"
        >
          Chat unavailable
        </button>
      ) : (
        <div
          id={
            isFinanceSection ? 'LP_DIV_1636108636356' : 'LP_DIV_1636108636354'
          }
          ref={liveChatRef}
        >
          {status === 'loading' && (
            <button
              className="ch-btn ch-btn--secondary ac-btn--loading ch-width--12"
              disabled
              type="button"
            >
              Web chat
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default LiveChatButton;

LiveChatButton.propTypes = {
  isFinanceSection: PropTypes.bool,
};
